import { Injectable } from '@angular/core';

import { orgaosRoute } from "./data.service";
import { estruturasRoute } from "../../shared/data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { newRoute, editRoute } from "../../../shared/services/data.service";

@Injectable()
export class OrgaoNavigationService {
  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = estruturasRoute + '/' + orgaosRoute;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = estruturasRoute + '/' + orgaosRoute + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = estruturasRoute + '/' + orgaosRoute + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/shared/orgao-navigation.service.ts
 **/